module.exports = __webpack_public_path__ + "static/power4-3-273622ead1cb7e825f67c39d271a7b28.png";